import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QuoteService {

  constructor(private api: ApiService) { }

  getAllQuote(data: any): Observable<any> {
    return this.api.post(environment.getAllQuote, data);
  }

  updateQuote(data: any): Observable<any> {
    return this.api.post(environment.updateQuote, data);
  }

  createQuote(data: any): Observable<any> {
    return this.api.post(environment.createQuote, data);
  }
  
  deleteQuote(data: any): Observable<any> {
    return this.api.post(environment.deleteQuote, data);
  }

  getQuoteAnalytics(data: any): Observable<any> {
    return this.api.post(environment.getQuoteAnalytics, data);
  }

  sendQuote(data: any): Observable<any> {
    return this.api.post(environment.sendQuote, data);
  }

  generateQuote(data: any): Observable<any> {
    return this.api.post(environment.generateQuote, data);
  }

  /**
   * Accept quote → backend creates CRM invoice, sends proforma + pay link to account email.
   * Pass from_email / emailProviderType when a user is logged in (same as Send Quote); otherwise server uses QUOTE_ACCEPT_FROM_EMAIL.
   */
  acceptQuoteFromLink(
    quoteId: number,
    clientId: number,
    extras?: {
      from_email?: string;
      emailProviderType?: string;
      companyName?: string;
    }
  ): Observable<any> {
    const root = String((environment as any).partCApiRoot || '').replace(/\/$/, '');
    const url = `${root}/acceptQuote/${quoteId}`;
    const body: Record<string, unknown> = { client_id: clientId };
    if (extras?.from_email) body['from_email'] = extras.from_email;
    if (extras?.emailProviderType) body['emailProviderType'] = extras.emailProviderType;
    if (extras?.companyName) body['companyName'] = extras.companyName;
    return this.api.post(url, body, { responseType: 'text' });
  }

  rejectQuoteFromLink(quoteId: number, clientId: number): Observable<any> {
    const root = String((environment as any).partCApiRoot || '').replace(/\/$/, '');
    const url = `${root}/rejectQuote/${quoteId}`;
    return this.api.post(url, { client_id: clientId }, { responseType: 'text' });
  }
}